import { createContext, useContext } from "react";

import { SideAccordionHelper } from "./SideAccordionHelper.tsx";

export const SideAccordionContext = createContext<SideAccordionHelper>(
  {} as SideAccordionHelper
);

export const useSideAccordionContext = () => useContext(SideAccordionContext);
